export { AddToRegistryTypeResolver } from "./AddToRegistryTypeResolver";
export { AssigneeTypeResolver } from "./AssigneeTypeResolver";
export { BaseEnumResolver } from "./BaseEnumResolver";
export { BaseResolver } from "./BaseResolver";
export { CitizenResolver } from "./CitizenResolver";
export { CommitDocumentTypeResolver } from "./CommitDocumentTypeResolver";
export { DepartmentResolver } from "./DepartmentResolver";
export { DigitalIdentityTypeResolver } from "./DigitalIdentityTypeResolver";
export { DocumentResolver } from "./DocumentResolver";
export { FormResolver } from "./FormResolver";
export { NotificationTypeResolver } from "./NotificationTypeResolver";
export { OfficialMonitorResolver } from "./OfficialMonitorResolver";
export { ProcedureDocumentsResolver } from "./ProcedureDocumentsResolver";
export { RegistratureResolver } from "./RegistratureResolver";
export { ServantResolver } from "./ServantResolver";
export { SignTypesResolver } from "./SignTypesResolver";
export { YesNoResolver } from "./YesNoResolver";
export { ReservedRegistrySpotResolver } from "./ReservedRegistrySpotResolver";
export { StatusResolver } from "./StatusResolver";
export { CollaboratorsResolver } from "./CollaboratorsResolver";
export { InstitutionFormResolver } from "./InstitutionFormResolver";
export { SignersResolver } from "./SignersResolver";
export { ReferenceResolver } from "./ReferenceResolver";
export { DepartmentsResolver } from "./DepartmentsResolver";
